import { render, staticRenderFns } from "./PoolInfo.vue?vue&type=template&id=2c67b5bc&"
import script from "./PoolInfo.vue?vue&type=script&lang=js&"
export * from "./PoolInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports